<section class="ai-graph-block">
  <div class="ai-chart-frame">
    <div class="ai-chart-row" *ngFor="let item of block.chart.data">
      <span class="ai-chart-label">{{ item.label }}</span>
      <div class="ai-chart-track">
        <span
          class="ai-chart-bar"
          [style.width]="barWidth(item.value, block.chart.maxValue)"
          [style.background]="item.color"
        >
          {{ item.value }}
        </span>
      </div>
    </div>
    <div class="ai-axis">
      <span>0</span>
      <span>500</span>
      <span>1000</span>
      <span>1500</span>
      <span>2000</span>
    </div>
  </div>

  <ul>
    <li *ngFor="let item of block.chart.data">
      <span class="ai-dot" [style.background]="item.color"></span>
      <strong>{{ item.label }} - {{ item.value }}:</strong>
      {{ item.description }}
    </li>
    <li *ngFor="let line of block.narration">
      {{ line }}
    </li>
  </ul>
</section>
